









































































































































































































































import {Component, Ref, Vue, Watch} from 'vue-property-decorator';
import {Nametag} from "@/design-system/constructs/Nametag/nametag.entity"
import faker from "@faker-js/faker"
import JdsDialog from "@/design-system/patterns/Dialog/JdsDialog.vue"
import JdsConfirmation from "@/design-system/patterns/Confirmation/JdsConfirmation.vue"

function build(team: string, role: string): () => Nametag {
    return () => {
        const name = [faker.name.firstName(), faker.name.lastName()]
        return {
            name: faker.name.findName(name[0], name[1]),
            email: faker.internet.email(name[0], name[1]),
            avatar: faker.internet.avatar(),
            avatarColor: faker.internet.color(),
            isJobillaStaff: true,
            unit: 'Jobilla Finland',
            team: team,
            role,
            setupCompletedAt: faker.date.past(5),
            lastActiveAt: faker.date.recent(3),
        }
    }
}

@Component({
    components: {
        JdsDialog
    }
})
export default class JdpAdminUnit extends Vue {
    @Ref() inviteDialog!: JdsDialog
    @Ref() moveUnitDialog!: JdsDialog
    @Ref() changeRoleDialog!: JdsDialog
    @Ref() deleteConfirmation!: JdsConfirmation
    @Ref() resendConfirmation!: JdsConfirmation
    @Ref() cancelConfirmation!: JdsConfirmation

    inviteName = ''
    inviteEmail = ''
    inviteLanguage = 'en'
    inviteRole = 'account-manager'

    deleteUser: Nametag|null = null
    moveDestinationUnit = 'intl'
    moveUnitUser: Nametag|null = null
    changeRoleNewRole = 'account-manager' // default to bottom
    changeRoleUser: Nametag|null = null


    members: Record<string, Array<Nametag>> = {
        salesDirectors: [],
        accountManagers: [],
        customerSuccessManagers: [],
        customerSuccessSpecialists: [],
    }

    mounted() {
        this.members = {
            salesDirectors: [...Array(1).keys()].map(build('Sales', 'Sales director')),
            accountManagers: [...Array(7).keys()].map(build('Sales', 'Account manager')),
            customerSuccessManagers: [...Array(1).keys()].map(build('Sales', 'Account manager')),
            customerSuccessSpecialists: [],
        }
        this.members.accountManagers[0].isPendingInvite = true
        this.members.accountManagers[1].isExpiredInvite = true
    }

    confirmDelete (i: Nametag) {
        this.deleteUser = i
        this.deleteConfirmation.confirm()
    }

    confirmCancelInvitation (i: Nametag) {
        this.cancelConfirmation.confirm()
    }

    confirmResendInvitation (i: Nametag) {
        this.resendConfirmation.confirm()
    }

    moveUnit (i: Nametag) {
        this.moveUnitUser = i
        this.moveUnitDialog.open()
    }

    changeRole (i: Nametag) {
        this.changeRoleUser = i
        this.changeRoleDialog.open()
    }

    invite() {
        this.inviteDialog.open()
    }
}
